import React from 'react';

interface TaskProgectsProps {
    fill?: string;
}

export const TaskProjects = ({ fill }: TaskProgectsProps) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2781_16962)">
                <path
                    d="M2 6.5H3.5V7.5H2V6.5ZM4.5 7.5H6V6.5H4.5V7.5ZM2 9.5H3.5V8.5H2V9.5ZM4.5 9.5H6V8.5H4.5V9.5ZM2 3.5H3.5V2.5H2V3.5ZM4.5 3.5H6V2.5H4.5V3.5ZM2 5.5H3.5V4.5H2V5.5ZM4.5 5.5H6V4.5H4.5V5.5ZM12 4V12H0V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0L6.5 0C6.89782 0 7.27936 0.158035 7.56066 0.43934C7.84196 0.720644 8 1.10218 8 1.5V2.5H10.5C10.8978 2.5 11.2794 2.65804 11.5607 2.93934C11.842 3.22064 12 3.60218 12 4ZM7 1.5C7 1.36739 6.94732 1.24021 6.85355 1.14645C6.75979 1.05268 6.63261 1 6.5 1H1.5C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24021 1 1.36739 1 1.5V11H7V1.5ZM11 4C11 3.86739 10.9473 3.74021 10.8536 3.64645C10.7598 3.55268 10.6326 3.5 10.5 3.5H8V11H11V4ZM9 7.5H10V6.5H9V7.5ZM9 9.5H10V8.5H9V9.5ZM9 5.5H10V4.5H9V5.5Z"
                    fill="#818998"
                />
            </g>
            <defs>
                <clipPath id="clip0_2781_16962">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
